require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-academy-cayman-islands.json") })
        }
      }, "path---blog-code-academy-cayman-islands");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-academy-cayman-islands!./.cache/json/blog-code-academy-cayman-islands.json
// module id = 765
// module chunks = 231608221292675